import React from 'react';
import Panel from '@finn-no/troika-react-panel';
import LoginImage from './illustrations/Illustration_Night.svg';
import trackLoginClick from './tracker';

function LoginBox() {
    return (
        <Panel className="login-box" type="info">
            <div className="u-text-center u-pt8">
                <LoginImage />
            </div>
            <h2 className="u-t4 u-text-center">Få mer ut av FINN</h2>
            <p className="u-text-center">
                Få varsler, send meldinger, legg til favoritter eller lagre
                søkene dine.
            </p>
            <p className="u-text-center u-pt8">
                <a
                    className="button button--cta u-size1of1"
                    href="/auth/login"
                    onClick={() => {
                        trackLoginClick();
                    }}
                >
                    Logg inn
                </a>
            </p>
            <p className="u-text-center u-d1">
                FINN.no er en del av Schibsted. Schibsted er ansvarlig for dine
                data på denne siden.
            </p>
            <p className="u-text-center u-d1">
                <a
                    href="https://info.privacy.schibsted.com/no/schibsted-norge-personvernerklaering/"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Les mer om personvern hos Schibsted
                </a>
            </p>
        </Panel>
    );
}

export default LoginBox;
